import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-238db28f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "no-overflow" }
const _hoisted_3 = { class: "main-loader" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "no-overflow" }
const _hoisted_6 = { class: "d-main-loader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_move_navigation = _resolveComponent("move-navigation")!
  const _component_create_folder = _resolveComponent("create-folder")!
  const _component_move_body = _resolveComponent("move-body")!
  const _component_app_small_loader = _resolveComponent("app-small-loader")!
  const _component_move_controls = _resolveComponent("move-controls")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_bottom_pop_up, {
          onHide: _ctx.hidePopUp,
          "hide-bottom-decoration": "",
          "hide-top-decoration": ""
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$localize('move.to.popup.title')), 1)
          ]),
          "top-right": _withCtx(() => []),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_move_navigation, {
                currentPosition: _ctx.currentFolderText,
                showDots: _ctx.showDots,
                onDrive: _ctx.goToDrive,
                onBack: _ctx.goBack
              }, null, 8, ["currentPosition", "showDots", "onDrive", "onBack"]),
              _createElementVNode("div", {
                class: "mixed",
                ref: "scroller",
                onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
              }, [
                (_ctx.isCreateFolder)
                  ? (_openBlock(), _createBlock(_component_create_folder, {
                      key: 0,
                      error: _ctx.createFolderError,
                      onClose: _ctx.cancelCreateFolder,
                      onSave: _ctx.createFolder,
                      onClearError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createFolderError = ''))
                    }, null, 8, ["error", "onClose", "onSave"]))
                  : _createCommentVNode("", true),
                (_ctx.mixedList && !_ctx.loader)
                  ? (_openBlock(), _createBlock(_component_move_body, {
                      key: 1,
                      mixedList: _ctx.mixedList,
                      onOpenFolder: _ctx.openFolder,
                      movingItem: _ctx.item,
                      loadingMore: _ctx.isPageLoading
                    }, null, 8, ["mixedList", "onOpenFolder", "movingItem", "loadingMore"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.loader)
                    ? (_openBlock(), _createBlock(_component_app_small_loader, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              ], 544),
              _createVNode(_component_move_controls, {
                onCancel: _ctx.cancel,
                onMove: _ctx.moveTo,
                onNewFolder: _ctx.openCreateFolder,
                disabledMove: _ctx.disableMove,
                "is-shared": !!_ctx.currentFolder?.share
              }, null, 8, ["onCancel", "onMove", "onNewFolder", "disabledMove", "is-shared"]),
              (_ctx.bigLoader)
                ? (_openBlock(), _createBlock(_component_app_loader, {
                    key: 0,
                    message: _ctx.bigLoader
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["onHide"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(_component_app_bottom_pop_up, {
          onHide: _ctx.hidePopUp,
          "hide-bottom-decoration": "",
          "hide-top-decoration": ""
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$localize('move.to.popup.title')), 1)
          ]),
          "top-right": _withCtx(() => []),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_move_navigation, {
                currentPosition: _ctx.currentFolderText,
                showDots: _ctx.showDots,
                onDrive: _ctx.goToDrive,
                onBack: _ctx.goBack
              }, null, 8, ["currentPosition", "showDots", "onDrive", "onBack"]),
              _createElementVNode("div", {
                class: "mixed desktop",
                ref: "scroller",
                onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
              }, [
                (_ctx.isCreateFolder)
                  ? (_openBlock(), _createBlock(_component_create_folder, {
                      key: 0,
                      error: _ctx.createFolderError,
                      onClose: _ctx.cancelCreateFolder,
                      onSave: _ctx.createFolder,
                      onClearError: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createFolderError = ''))
                    }, null, 8, ["error", "onClose", "onSave"]))
                  : _createCommentVNode("", true),
                (_ctx.mixedList && !_ctx.loader)
                  ? (_openBlock(), _createBlock(_component_move_body, {
                      key: 1,
                      mixedList: _ctx.mixedList,
                      onOpenFolder: _ctx.openFolder,
                      movingItem: _ctx.item,
                      loadingMore: _ctx.isPageLoading
                    }, null, 8, ["mixedList", "onOpenFolder", "movingItem", "loadingMore"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.loader)
                    ? (_openBlock(), _createBlock(_component_app_small_loader, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              ], 544),
              (_ctx.bigLoader)
                ? (_openBlock(), _createBlock(_component_app_loader, {
                    key: 0,
                    message: _ctx.bigLoader
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_move_controls, {
              onCancel: _ctx.cancel,
              onMove: _ctx.moveTo,
              onNewFolder: _ctx.openCreateFolder,
              disabledMove: _ctx.disableMove,
              "is-shared": !!_ctx.currentFolder?.share,
              class: "d-contols"
            }, null, 8, ["onCancel", "onMove", "onNewFolder", "disabledMove", "is-shared"])
          ]),
          _: 1
        }, 8, ["onHide"])
      ]))
}